enum REFUND_TYPES {
  DISCOUNT_REFUND = 'DISCOUNT_REFUND',
  EXCHANGE_REFUND = 'EXCHANGE_REFUND',
  ITEM_PRICE_REFUND = 'ITEM_PRICE_REFUND',
  RESTOCKING_FEE = 'RESTOCKING_FEE',
  SHIPPING_REFUND = 'SHIPPING_REFUND',
  TAX_REFUND = 'TAX_REFUND',
  TOTAL_REFUND = 'TOTAL_REFUND',
}

export default REFUND_TYPES
